<template>
	<div>
		<h4 class="section-title">Employees</h4>
		<provider-list></provider-list>

	</div>
</template>

<script>

	export default {
		data : function(){
			return {
				permissions : []
			}
		},

		created : function(){
			let root = document.documentElement;
            root.style.setProperty('--dropdown-color', '#f9f9f9');
			this.permissions = this.$store.getters.getPermissions;
		},

		methods : {

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/organizations/providers/OrganizationProviderListComponent.vue